import React, { useState } from 'react';
import './Version.scss';

const Version: React.FC = () => {
    return (
        <div className="versionBox">
            {
                `Deploy: ${ process.env.REACT_APP_LAST_DEPLOY } | Versión: ${ process.env.REACT_APP_VERSION }`
            }
        </div>
    );
};

export default Version;
